import { convertToIST_NEW } from '../timeFormatter';

export const TemperatureTableConfig = [
	{
		title: 'Trip ID',
		dataIndex: 'trip_id',
		key: 'trip_id',
	},
	{
		title: 'City',
		dataIndex: 'city',
		key: 'city',
	},
	{
		title: 'Vendor Name',
		dataIndex: 'vendor_name',
		key: 'vendor_name',
	},
	{
		title: 'Project Location',
		dataIndex: 'project_location_code',
		key: 'project_location_code',
	},
	{
		title: 'Vehicle Number',
		dataIndex: 'vehicle_number',
		key: 'vehicle_number',
		render: (vehicle_number, record) => (
			<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
				<span>{vehicle_number}</span>
				{record.current_load_status === 'loaded' ? (
					<svg
						width="24"
						height="25"
						viewBox="0 0 24 25"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M18 4.5H13V13.5H1V17.5H3C3 18.33 3.3 19.03 3.89 19.63C4.5 20.22 5.19 20.5 6 20.5C6.81 20.5 7.5 20.22 8.11 19.63C8.7 19.03 9 18.33 9 17.5H14.5C14.5 18.33 14.78 19.03 15.38 19.63C15.97 20.22 16.67 20.5 17.5 20.5C18.3 20.5 19 20.22 19.59 19.63C20.19 19.03 20.5 18.33 20.5 17.5H23V10.5L18 4.5ZM7.08 18.57C6.8 18.87 6.44 19 6 19C5.56 19 5.2 18.87 4.92 18.57C4.64 18.27 4.5 17.92 4.5 17.5C4.5 17.11 4.64 16.76 4.92 16.46C5.2 16.16 5.56 16 6 16C6.44 16 6.8 16.16 7.08 16.46C7.36 16.76 7.5 17.11 7.5 17.5C7.5 17.92 7.36 18.27 7.08 18.57ZM18.54 18.57C18.24 18.87 17.89 19 17.5 19C17.08 19 16.73 18.87 16.43 18.57C16.13 18.27 16 17.92 16 17.5C16 17.11 16.13 16.76 16.43 16.46C16.73 16.16 17.08 16 17.5 16C17.89 16 18.24 16.16 18.54 16.46C18.84 16.76 19 17.11 19 17.5C19 17.92 18.84 18.27 18.54 18.57ZM15 10.5V6.5H17.06L20.39 10.5H15Z"
							fill="#389E0E"
						/>
						<rect y="4.05554" width="12" height="8.44444" fill="#389E0E" />
					</svg>
				) : (
					<svg
						width="22"
						height="17"
						viewBox="0 0 22 17"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17 0.5H12V9.5H0V13.5H2C2 14.33 2.3 15.03 2.89 15.63C3.5 16.22 4.19 16.5 5 16.5C5.81 16.5 6.5 16.22 7.11 15.63C7.7 15.03 8 14.33 8 13.5H13.5C13.5 14.33 13.78 15.03 14.38 15.63C14.97 16.22 15.67 16.5 16.5 16.5C17.3 16.5 18 16.22 18.59 15.63C19.19 15.03 19.5 14.33 19.5 13.5H22V6.5L17 0.5ZM6.08 14.57C5.8 14.87 5.44 15 5 15C4.56 15 4.2 14.87 3.92 14.57C3.64 14.27 3.5 13.92 3.5 13.5C3.5 13.11 3.64 12.76 3.92 12.46C4.2 12.16 4.56 12 5 12C5.44 12 5.8 12.16 6.08 12.46C6.36 12.76 6.5 13.11 6.5 13.5C6.5 13.92 6.36 14.27 6.08 14.57ZM17.54 14.57C17.24 14.87 16.89 15 16.5 15C16.08 15 15.73 14.87 15.43 14.57C15.13 14.27 15 13.92 15 13.5C15 13.11 15.13 12.76 15.43 12.46C15.73 12.16 16.08 12 16.5 12C16.89 12 17.24 12.16 17.54 12.46C17.84 12.76 18 13.11 18 13.5C18 13.92 17.84 14.27 17.54 14.57ZM14 6.5V2.5H16.06L19.39 6.5H14Z"
							fill="#FF0E00"
						/>
					</svg>
				)}
			</div>
		),
	},
	{
		title: 'Temperature Range',
		dataIndex: 'temperature_range',
		key: 'temperature',
		render: (_, record) => {
			const min = record.minimum_temperature;
			const max = record.maximum_temperature;

			if (min === null || max === null || min === undefined || max === undefined) return '-';
			if (min === '' && max === '') return '-';

			const minStr = parseFloat(min).toString();
			const maxStr = parseFloat(max).toString();

			if (Number.isNaN(parseFloat(min)) && Number.isNaN(parseFloat(max))) return '-';
			return <span>{`${minStr} - ${maxStr} °C`}</span>;
		},
	},
	{
		title: 'Temperature (°C)',
		dataIndex: 'temperature',
		key: 'temperature',
		render: (value) => {
			if (value === null || value === undefined || value === '') return <span>-</span>;
			if (value === 0 || value === '0') return <span>0°C</span>;
			const parsedValue = parseFloat(value);
			if (Number.isNaN(parsedValue)) return <span>-</span>;
			return <span>{parsedValue.toString()}°C</span>;
		},
	},
	{
		title: 'Duration',
		dataIndex: 'created_at',
		key: 'duration',
		render: (value) => {
			if (!value) return <span>-</span>;

			try {
				const [datePart, timePart] = value.split(' ');
				const [month, day, year] = datePart.split('/');

				const createdDate = new Date(`${year}-${month}-${day}T${timePart}`);

				const now = new Date();

				const diffMs = now.getTime() - createdDate.getTime() - 1000 * 60 * 60 * 5.5;

				const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
				const diffMinutes = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));

				if (diffHours > 0) {
					return (
						<span>
							{diffHours}hr {diffMinutes}min
						</span>
					);
				}
				return <span>{diffMinutes}min</span>;
			} catch (error) {
				console.error('Error calculating time difference:', error);
				return <span>-</span>;
			}
		},
	},
	{
		title: 'Battery',
		dataIndex: 'battery',
		key: 'battery',
		render: (value) => {
			if (value === null || value === undefined || value === '') return <span>-</span>;
			if (value === 0 || value === '0') return <span>0 V</span>;
			const parsedValue = parseFloat(value);
			if (Number.isNaN(parsedValue)) return <span>-</span>;
			return <span>{parsedValue.toString()} V</span>;
		},
	},
	{
		title: 'Status',
		dataIndex: 'status',
		key: 'status',
	},
	{
		title: 'Last Sync',
		dataIndex: 'last_sync',
		key: 'last_sync',
		render: (value) => {
			if (value === null || value === undefined || value === '') return <span>-</span>;
			const formattedDate = convertToIST_NEW(value);
			return <span>{formattedDate}</span>;
		},
	},
	{
		title: 'Actions',
		key: 'actions',
		width: 80,
		align: 'center',
		render: (_, record) => (
			/* eslint-disable-next-line jsx-a11y/control-has-associated-label */
			<button
				type="button"
				style={{
					border: 'none',
					background: 'transparent',
					cursor: 'pointer',
					padding: '4px',
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'center',
				}}
				onClick={() => {
					// This will be handled by the parent component
					if (window.onLoadingHistoryClick) {
						window.onLoadingHistoryClick(record);
					}
				}}
				title="View Loading History"
				aria-label="View Loading History"
			>
				<svg
					width="18"
					height="21"
					viewBox="0 0 18 21"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
				>
					<path
						d="M3.9375 4.5C3.83437 4.5 3.75 4.58437 3.75 4.6875V5.8125C3.75 5.91563 3.83437 6 3.9375 6H12.9375C13.0406 6 13.125 5.91563 13.125 5.8125V4.6875C13.125 4.58437 13.0406 4.5 12.9375 4.5H3.9375ZM8.4375 9.1875V8.0625C8.4375 7.95937 8.35312 7.875 8.25 7.875H3.9375C3.83437 7.875 3.75 7.95937 3.75 8.0625V9.1875C3.75 9.29062 3.83437 9.375 3.9375 9.375H8.25C8.35312 9.375 8.4375 9.29062 8.4375 9.1875ZM7.3125 18.4688H1.875V1.96875H15V10.0312C15 10.1344 15.0844 10.2188 15.1875 10.2188H16.5C16.6031 10.2188 16.6875 10.1344 16.6875 10.0312V1.03125C16.6875 0.616406 16.3523 0.28125 15.9375 0.28125H0.9375C0.522656 0.28125 0.1875 0.616406 0.1875 1.03125V19.4062C0.1875 19.8211 0.522656 20.1562 0.9375 20.1562H7.3125C7.41563 20.1562 7.5 20.0719 7.5 19.9688V18.6562C7.5 18.5531 7.41563 18.4688 7.3125 18.4688ZM9.75234 15.7594C9.79453 14.9508 10.132 14.1938 10.7086 13.6172C11.3227 13.0031 12.1617 12.6562 13.0312 12.6562C13.9078 12.6562 14.7328 12.9984 15.3539 13.6172C15.4289 13.6922 15.5016 13.7719 15.5695 13.8539L15.0281 14.2734C15.0002 14.295 14.979 14.3241 14.9668 14.3572C14.9547 14.3903 14.9521 14.4262 14.9595 14.4608C14.9668 14.4953 14.9837 14.527 15.0083 14.5524C15.0329 14.5777 15.0641 14.5955 15.0984 14.6039L17.2852 15.1312C17.4023 15.1594 17.5148 15.0703 17.5172 14.9508L17.5312 12.7148C17.5316 12.6796 17.522 12.645 17.5036 12.615C17.4852 12.585 17.4586 12.5607 17.4271 12.5451C17.3955 12.5294 17.3602 12.523 17.3252 12.5265C17.2901 12.53 17.2567 12.5433 17.2289 12.5648L16.7531 12.9352C15.8766 11.85 14.5336 11.1562 13.0312 11.1562C10.4555 11.1562 8.35312 13.193 8.25 15.743C8.24531 15.8484 8.33203 15.9375 8.4375 15.9375H9.56484C9.66562 15.9375 9.74766 15.8602 9.75234 15.7594ZM17.625 15.9375H16.4977C16.3969 15.9375 16.3148 16.0148 16.3102 16.1156C16.268 16.9242 15.9305 17.6812 15.3539 18.2578C14.7398 18.8719 13.9008 19.2188 13.0312 19.2188C12.1547 19.2188 11.3297 18.8766 10.7086 18.2578C10.6336 18.1828 10.5609 18.1031 10.493 18.0211L11.0344 17.6016C11.0623 17.58 11.0835 17.5509 11.0957 17.5178C11.1078 17.4847 11.1104 17.4488 11.103 17.4142C11.0957 17.3797 11.0788 17.348 11.0542 17.3226C11.0296 17.2973 10.9984 17.2795 10.9641 17.2711L8.77734 16.7438C8.66016 16.7156 8.54766 16.8047 8.54531 16.9242L8.53125 19.1602C8.53091 19.1954 8.54051 19.23 8.55893 19.26C8.57735 19.29 8.60386 19.3143 8.63541 19.3299C8.66696 19.3456 8.70229 19.352 8.73734 19.3485C8.77239 19.345 8.80575 19.3317 8.83359 19.3102L9.30938 18.9398C10.1859 20.025 11.5289 20.7188 13.0312 20.7188C15.607 20.7188 17.7094 18.682 17.8125 16.132C17.8172 16.0266 17.7305 15.9375 17.625 15.9375Z"
						fill="#006FC5"
					/>
				</svg>
			</button>
		),
	},
];
